<template>
  <div class="contact-container">
    <!-- 顶部导航栏 -->
    <!-- <Top /> -->

    <!-- 页面头部 Banner -->
    <div class="page-banner">
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <h1>联系我们</h1>
        <p>我们随时为您提供专业的咨询与服务支持</p>
      </div>
    </div>

    <!-- 核心内容区 -->
    <div class="container contact-content">
      <!-- 联系方式卡片 -->
      <section class="contact-section">
        <h2 class="section-title">联系方式</h2>
        <div class="contact-cards">
          <!-- 客服热线 -->
          <div class="contact-card">
            <div class="contact-icon">📞</div>
            <h3>客服热线</h3>
            <p class="contact-info">130-5185-0850</p>
            <p class="contact-desc">工作日 9:00-18:00</p>
          </div>
          <!-- 官方邮箱 -->
          <div class="contact-card">
            <div class="contact-icon">✉️</div>
            <h3>官方邮箱</h3>
            <p class="contact-info">zhibuyunshang@swocs.com.cn</p>
            <p class="contact-desc">工作日 24 小时内回复</p>
          </div>
        </div>
      </section>

      <!-- 留言反馈区（可选） -->
      <!-- <section class="contact-section">
        <h2 class="section-title">留言反馈</h2>
        <div class="feedback-form">
          <el-form :model="form" label-width="80px">
            <el-form-item label="您的姓名">
              <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话">
              <el-input v-model="form.phone" placeholder="请输入您的联系电话"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱">
              <el-input v-model="form.email" placeholder="请输入您的电子邮箱"></el-input>
            </el-form-item>
            <el-form-item label="反馈内容">
              <el-input type="textarea" v-model="form.content" placeholder="请详细描述您的问题或建议" rows="4"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSubmit" :loading="submitting">提交反馈</el-button>
            </el-form-item>
          </el-form>
        </div>
      </section> -->
    </div>

    <!-- 底部导航 -->
    <!-- <Bottom /> -->
  </div>
</template>

<script>
import Top from '../../components/Header.vue';
import Bottom from '../../components/Footer.vue';

export default {
  name: 'ContactUs',
  components: {
    Top,
    Bottom
  },
  data() {
    return {
      form: {
        name: '',
        phone: '',
        email: '',
        content: ''
      },
      submitting: false
    };
  },
  methods: {
    handleSubmit() {
      this.submitting = true;
      // 模拟提交接口
      setTimeout(() => {
        this.$message.success('反馈提交成功，我们将尽快与您联系！');
        this.form = { name: '', phone: '', email: '', content: '' };
        this.submitting = false;
      }, 1000);
    }
  }
};
</script>

<style lang="less" scoped>
// 继承全局主题色
@base-deep: #0f1118;
@base-darker: #080a12;
@primary: #0ea5e9;
@primary-light: #38bdf8;
@text-primary: #fff;
@text-secondary: #94a3b8;
@border-color: rgba(148, 163, 184, 0.1);

.contact-container {
  background-color: @base-deep;
  color: @text-primary;
  min-height: 100vh;
}

// 页面Banner
.page-banner {
  position: relative;
  height: 300px;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: url('../../assets/banner/2.png') no-repeat 100% 100%;

  .banner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    opacity: 0.5;
  }

  .banner-content {
    position: relative;
    z-index: 2;
    text-align: center;

    h1 {
      font-size: 2.5rem;
      margin-bottom: 1rem;
      text-shadow: 0 3px 15px rgba(14, 165, 233, 0.4);
    }

    p {
      font-size: 1.2rem;
      color: @text-secondary;
      max-width: 600px;
      margin: 0 auto;
    }
  }
}

// 内容容器
.contact-content {
  padding: 3rem 0;
  max-width: 1200px;
  margin: 0 auto;
}

.contact-section {
  margin-bottom: 4rem;
}

.section-title {
  font-size: 2rem;
  color: @primary-light;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid @primary;
  display: inline-block;
}

// 联系方式卡片
.contact-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.contact-card {
  background-color: @base-darker;
  border: 1px solid @border-color;
  border-radius: 12px;
  padding: 2.5rem;
  text-align: center;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(14, 165, 233, 0.15);
    border-color: @primary;
  }

  .contact-icon {
    font-size: 3.5rem;
    margin-bottom: 1rem;
  }

  h3 {
    font-size: 1.8rem;
    color: @text-primary;
    margin-bottom: 1rem;
  }

  .contact-info {
    font-size: 1.5rem;
    color: @primary-light;
    margin-bottom: 0.5rem;
    word-break: break-all;
  }

  .contact-desc {
    font-size: 1.1rem;
    color: @text-secondary;
  }
}

// 反馈表单
.feedback-form {
  max-width: 600px;
  background-color: @base-darker;
  border: 1px solid @border-color;
  border-radius: 12px;
  padding: 2rem;
}

// 覆盖Element UI默认样式
:deep(.el-form-item__label) {
  color: @text-primary;
}

:deep(.el-input__inner) {
  background-color: rgba(30, 41, 59, 0.5);
  border-color: @border-color;
  color: @text-primary;
}

:deep(.el-input__inner::placeholder) {
  color: @text-secondary;
}

:deep(.el-button--primary) {
  background-color: @primary;
  border-color: @primary;
}

:deep(.el-button--primary:hover) {
  background-color: @primary-light;
  border-color: @primary-light;
}

// 响应式适配
@media (max-width: 768px) {
  .page-banner {
    height: 200px;

    .banner-content h1 {
      font-size: 1.8rem;
    }

    .banner-content p {
      font-size: 1rem;
    }
  }

  .section-title {
    font-size: 1.5rem;
  }

  .contact-cards {
    grid-template-columns: 1fr;
  }

  .feedback-form {
    padding: 1.5rem;
  }
}
</style>